import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogIn } from './LogIn';
import { checkLoggedIn } from '../functions/CookieHelper';

export const Home = () => {
    const { t } = useTranslation();
    const [loggedIn] = useState(checkLoggedIn());
    const [user, setUser] = useState({});

    useEffect(() => {
        if (loggedIn) {
            const loadUser = async () => {
                const response = await fetch('api/identity/getuser');
                const data = await response.json();
                setUser(data);
                console.log('user', data);
            }
            loadUser();
        }
    }, [loggedIn]);

    // Anonymous visitors get the full-bleed landing hero, which carries its own
    // "Welcome to DrillTrak" title — so it is returned without the centred wrapper.
    if (!loggedIn) {
        return <LogIn />;
    }

    const content = (
        <div>
            <Link to="/overview" className="btn btn-primary">{t('nav.projects')}</Link>
            {user && user.customer === 'Capital' && (
                <div>
                    <br />
                    <Link to="/hammertrak/portal" className="btn btn-primary">{t('home.goToHammerTrak')}</Link>
                </div>
            )}
            {user && user.roles && user.roles.some(r => r.toLowerCase() === 'admin') && (
                <div>
                    <br />
                    <Link to="/admin/users" className="btn btn-primary">{t('nav.manageUsers')}</Link>
                </div>
            )}
        </div>
    );

    return (
        <div className="text-center">
            <h1>{t('common.welcome')}</h1>
            {content}
        </div>
    );
}
